/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePrimaryVirtualContainerData } from '../../models/create-primary-virtual-container-data';

export interface GetPrimaryVirtualContainerCreationData$Params {
  productionOrderId: number;
}

export function getPrimaryVirtualContainerCreationData(http: HttpClient, rootUrl: string, params: GetPrimaryVirtualContainerCreationData$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePrimaryVirtualContainerData>> {
  const rb = new RequestBuilder(rootUrl, getPrimaryVirtualContainerCreationData.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePrimaryVirtualContainerData>;
    })
  );
}

getPrimaryVirtualContainerCreationData.PATH = '/api/v1/PrimaryMaterial/{productionOrderId}/GetPrimaryVirtualContainerCreationData';
